export default __webpack_public_path__ + "static/media/right.9a224f24.png";